import { ContentTable, TableCell } from "pdfmake/interfaces";

import { tableLayout } from "./default-styles";
import { DocumentContext } from "./document-context";
import { observationToDisplay } from "./utils";
import { FallObservationReportData } from "../reports/types";

const linkedObservationRow = (ctx: DocumentContext, link: FallObservationReportData["links"][number]): TableCell[] => [
	{
		text: observationToDisplay.type(
			link.observationSummary.observationSubType ?? link.observationSummary.observationType,
			ctx.locale,
		),
	},
	{ text: observationToDisplay.occurredOn(link.observationSummary.occurredOn, ctx.locale) },
	link.linkType === "CAUSED_BY"
		? { text: ctx.t("features/pdf-generation.linkedObservations.table.causedBy"), style: "warningText" }
		: { text: ctx.t("features/pdf-generation.linkedObservations.table.consequence"), style: "errorText" },
];

export const linkedObservationsTable = (
	ctx: DocumentContext,
	links: FallObservationReportData["links"],
): ContentTable => ({
	layout: tableLayout,
	table: {
		headerRows: 1,
		widths: ["auto", "*", "auto"],
		body: [
			[
				{
					text: ctx.t("features/pdf-generation.linkedObservations.table.header.type"),
					bold: true,
					border: [false, false, false, true],
				},
				{
					text: ctx.t("features/pdf-generation.linkedObservations.table.header.occurredOn"),
					bold: true,
					border: [false, false, false, true],
				},
				{ text: "", border: [false, false, false, true] },
			],
			...links.map((col) => linkedObservationRow(ctx, col)),
		],
	},
	style: { lineHeight: 1 },
});
